




















import { Component, Vue } from 'nuxt-property-decorator';
import { computed } from '@nuxtjs/composition-api';

import { useKeyValueStore } from '@/composables/key-value-store';

@Component({
  setup () {
    const phone = useKeyValueStore('contact_phone');
    const email = useKeyValueStore('contact_email');
    const invoiceDetails = useKeyValueStore('invoice_details');
    const openingHoursUrl = useKeyValueStore('opening_hours_url');
    const formattedPhone = computed(() => phone.value?.replace(/[^\d]/g, ''));

    return {
      phone,
      email,
      formattedPhone,
      invoiceDetails,
      openingHoursUrl,
    };
  },
})
export default class SiteFooterContactList extends Vue {
  phone!: string;
  email!: string;
  formattedPhone!: string;
  invoiceDetails!: string;
  openingHoursUrl!: string;
}
